/**
 * @generated SignedSource<<8dd8b586214e7f8a7f5a3cd78e62b4ef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation$variables = {
  taskID: number;
};
export type salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation$data = {
  readonly completePaymentMethodSetupTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation = {
  response: salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation$data;
  variables: salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskID",
        "variableName": "taskID"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "completePaymentMethodSetupTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "535fd4c50d32f761603c1a863d59a918",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSwitchQueriesCompletePaymentMethodSetupTaskMutation(\n  $taskID: Long!\n) {\n  completePaymentMethodSetupTask(taskID: $taskID) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3feb3d0d6c3efb58d1a2261d381f93a";

export default node;
